<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="标题">
                    <el-input v-model="query.keyword" placeholder="请输入标题" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="query.status" placeholder="全部" clearable>
                        <el-option v-for="(item, index) in status_array" :label="item" :value="index" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建时间">
                    <div class="block">
                        <span class="demonstration"></span>
                        <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--添加等级-->
<!--        <div class="common-level-rail">-->
<!--            <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus" v-auth="'/education/exam/add'">添加考试</el-button>-->
<!--        </div>-->
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="wish_id" label="心愿ID" width="80"></el-table-column>
                    <el-table-column prop="title" label="标题"></el-table-column>
                    <el-table-column prop="user" label="发布用户" width="100">
                        <template slot-scope="scope">
                            {{ scope.row.user ?  scope.row.user.nickName : ''}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="wish_category_desc" label="分类" width="100">
                        <template slot-scope="scope">
                           {{ scope.row.category ?  scope.row.category.name : ''}}
                        </template>
                    </el-table-column>

<!--                    <el-table-column prop="" label="图片" width="100">-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-image style="height: 40px" fit="contain" v-if="scope.row.file_path" class="ya-img-table" :src="scope.row.file_path"-->
<!--                                      :preview-src-list="[scope.row.file_path]" title="点击查看大图" />-->
<!--                        </template>-->
<!--                    </el-table-column>-->

                    <el-table-column prop="claim_num" label="总认领人数" width="100"></el-table-column>
                    <el-table-column prop="joined_num" label="已认领人数" width="100"></el-table-column>
                    <el-table-column prop="status_desc" label="状态" width="100"></el-table-column>
                    <el-table-column prop="end_time" label="截止时间" width="150"></el-table-column>
<!--                    <el-table-column prop="sort" label="排序" width="60"></el-table-column>-->
                    <el-table-column prop="create_time" label="添加时间" width="150"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="180">
                        <template slot-scope="scope">
                            <el-button @click="handleWishClose(scope.row)" type="text" size="small" v-if="scope.row.status === 10" v-auth="'/education/wish/wishClose'">提前结束</el-button>
                            <el-button @click="handlDetail(scope.row)" type="text" size="small" v-auth="'/education/wish/detail'">详情</el-button>
                            <el-button @click="handlAudit(scope.row)" type="text" size="small" v-if="scope.row.status === 0 || scope.row.status === 20" v-auth="'/education/wish/audit'">审核</el-button>
                            <el-button @click="handleDelete(scope.row)" type="text" size="small" v-auth="'/education/wish/del'">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="query.page"
                        :page-size="query.list_rows"
                        layout="total, prev, pager, next, jumper"
                        :total="total"></el-pagination>
            </div>
        </div>
        <!--添加编辑-->
<!--        <edit ref="edit" @fetch-data="refresh"></edit>-->
        <audit ref="audit" @fetch-data="search" />
        <detail ref="detail" />

    </div>
</template>

<script>
    import {wishList, wishDel, wishClose} from '@/api/education';
    import Audit from '@/views/education/audit/audit';
    import Detail from './detail'

    export default {
        components: {
            Audit,
            Detail,
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                total: 0,
                /*横向表单数据模型*/
                form: {
                    become: '0'
                },
                query: {
                    status: '',
                    create_time: '',
                    keyword: '',
                    page: 1,
                    list_rows: 10,
                },
                status_array: [],

            };
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*获取列表*/
            getTableList() {
                this.loading = true
                wishList(this.query).then((result)=>{
                    this.loading = false
                    this.status_array = result.data.status_array
                    this.tableData = result.data.list
                    this.total = result.data.count
                })
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },
            // 审核
            handlAudit(row){
                let data = {
                    audit_id: 0,
                    target_id: row.wish_id,
                    audit_type: 1, // 心愿
                }
                if(row.audit){
                    if(row.audit.audit_id > 0){
                        data.audit_id = row.audit.audit_id
                    }
                }
                this.$refs['audit'].showDialog(data)
            },
            handlDetail(row){
                this.$refs['detail'].showDialog(row)
            },
            // // 添加
            // handleAdd(){
            //     this.$refs['edit'].showDialog()
            // },
            // // 编辑
            // handleEdit(row) {
            //     this.$refs['edit'].showDialog(row)
            // },

            handleWishClose(row){
                if (row.wish_id) {
                    this.$confirm('确定要提前结束吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        wishClose({id: row.wish_id}).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.getTableList()
                        })
                    }).catch(() => {

                    });
                }
            },

            // 删除
            handleDelete(row) {
                if (row.wish_id) {
                    this.$confirm('确定要删除当前项吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        wishDel({ids: row.wish_id}).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.getTableList()
                        })
                    }).catch(() => {

                    });
                } else {
                    // if (this.selection.length > 0) {
                    //     this.$confirm('确定要删除选中项吗?', '提示', {
                    //         confirmButtonText: '确定',
                    //         cancelButtonText: '取消',
                    //         type: 'warning'
                    //     }).then(() => {
                    //         agentDel({ids: this.selectIds}).then((result)=>{
                    //             this.$message({type: 'success', message: result.msg});
                    //             this.list()
                    //         })
                    //     }).catch(() => {
                    //
                    //     });
                    //
                    // } else {
                    //     this.$message({type: 'error', message: '未选中任何项'});
                    // }
                }
            },
            //选择第几页
            handleCurrentChange(val) {
                this.query.page = val;
                this.getTableList();
            },
            //每页多少条
            handleSizeChange(val) {
                this.query.list_rows = val;
                this.getTableList();
            },
            // 切换题目类型时
            questionTypeChange(val){
               this.query.exam_type = val
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/education/wish/wish/index.vue